import { render, staticRenderFns } from "./badge-count.vue?vue&type=template&id=37a74aae&"
import script from "./badge-count.vue?vue&type=script&lang=js&"
export * from "./badge-count.vue?vue&type=script&lang=js&"
import style0 from "./badge-count.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports